import { Controller } from '@hotwired/stimulus'

// The "Registro rápido" (+) launcher (ux-design §3.5). Toggles the short menu
// open/closed and keeps the trigger's aria-expanded in sync; closes on Escape or
// an outside click. One tap to open, one tap to pick — the capture stays fast.
export default class extends Controller {
  static targets = ['menu', 'trigger']

  toggle () {
    this.setOpen(this.menuTarget.hidden)
  }

  close () {
    this.setOpen(false)
  }

  closeOnOutside (event) {
    if (!this.element.contains(event.target)) this.close()
  }

  setOpen (open) {
    this.menuTarget.hidden = !open
    if (this.hasTriggerTarget) this.triggerTarget.setAttribute('aria-expanded', String(open))
  }
}
